// Unpublished Work © 2025 Deere & Company.

import {
    SET_REMOVE_VISIBILITY_ERROR
} from '../../action-list';
import {RemoveVisibilityError} from '../../state/struct/profile/removeVisibilityError';

const setRemoveVisibilityError = (state, action) => {
    const errorMessage = action.removeVisibilityError?.errorMessage;

    return {
        hasError: Boolean(errorMessage),
        errorMessage
    };
};

export function removeVisibilityError(state = new RemoveVisibilityError({}), action = {}) {
    const actionHandlers = {
        [SET_REMOVE_VISIBILITY_ERROR]: setRemoveVisibilityError
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}
